<template>
  <div class="check-uid-con" v-show="isRender">
    <div :class="bindInputClass">
      <input
        id="check-uid-input"
        ref="check-uid-input"
        v-model="checkUidValue"
        autocomplete="off"
        :type="inputType"
        :inputmode="inpuTmode"
        :placeholder="placeholderText"
        @input="handleInput"
        @blur="handleBlur"
        @focus="handleFocus"
        @keyup.enter="handleBlur"
        :class="bindUidClass"
        :style="bindInputStyle"
      />
    </div>
  </div>
</template>

<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { chineseReg } from '@/utils/regExp'
  import { mapGetters, mapMutations, mapState } from 'vuex'
  import { hexToRgba } from '@/utils/hexToRgba'
  import { storage } from '@/utils/storage'
  export default {
    mixins: [styleConfiguration],
    data() {
      return {
        isRender: true,
        checkUidValue: '',
        validator: {
          isInInput: false, // 是否在输入中
          isError: false, // 验证错误
          isSuccess: false, // 验证成功
          isLoading: false, // 验证中
          errorCode: 0,
        },
        inputmode: {
          tel: 'numeric',
          text: 'email',
        },
      }
    },
    computed: {
      ...mapState(['isDesktop', 'isMobile']),
      ...mapState('detail', ['userId']),
      ...mapGetters([
        'firstCacheGamesKey',
        'isNotCheckGames',
        'isAllExternalGames',
      ]),
      placeholderText() {
        return this.$t(`publicDetails.repeat_uid_title`, {
          uid: 'UID',
        })
      },
      inputType() {
        return 'text'
      },
      inpuTmode() {
        return this.inputmode[this.inputType]
      },

      bindInputStyle() {
        return {
          backgroundColor: this.skuBackColor.backgroundColor,
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
          '--placeholderColor': hexToRgba(this.mFontColor.color),
        }
      },
      bindInputClass() {
        const defaultClass = ['special-check-uid-content']
        let device = []

        if (this.isDesktop) {
          device.push(`${defaultClass[0]}-desktop`)
        }
        if (this.isMobile) {
          device.push(`${defaultClass[0]}-mobile`)
        }
        return defaultClass.concat(device)
      },
      bindUidClass() {
        const classnames = ['check-uid-input']
        let classTypes = []
        if (this.isDesktop) {
          classTypes.push('desktop-input')
        }
        return classnames.concat(classTypes)
      },
    },
    watch: {},
    mounted() {
      this.firstLoad()
    },
    methods: {
      ...mapMutations([
        'detail/setCheckffuid',
        'detail/setRenderCheckffuid',
        'detail/setUidValidator',
      ]),
      firstLoad() {
        if (this.isNotCheckGames) {
          const isCacheKey = this.hackffTag()
          if (!isCacheKey) {
            this.isRender = true
            this.hackffTag('set')
          } else {
            this.isRender = false
          }
        } else {
          this.isRender = false
        }

        this['detail/setRenderCheckffuid'](this.isRender)
      },
      handleCheck({
        isInInput = false,
        isError = false,
        isSuccess = false,
        isLoading = false,
        errorCode = 0,
      } = {}) {
        this.validator = {
          isInInput,
          isError,
          isSuccess,
          isLoading,
          errorCode,
        }
        this['detail/setUidValidator'](this.validator)
      },

      hackffTag(type = 'get') {
        if (type === 'get') {
          return storage.get(this.firstCacheGamesKey) || false
        }
        if (type === 'set') {
          storage.set(this.firstCacheGamesKey, true)
        }
      },

      handleInput() {
        if (this.isAllExternalGames) {
          this.checkUidValue = this.checkUidValue.replace(chineseReg, '')
        }
        // this.checkUidValue = this.checkUidValue.replace(/\D/g, '')
      },
      handleBlur() {
        if (this.userId !== this.checkUidValue) {
          this.handleCheck({ isError: true, errorCode: 200 })
        } else {
          this.handleCheck()
        }
        this['detail/setCheckffuid'](this.checkUidValue)
      },
      handleFocus() {},
    },
  }
</script>

<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
